{
	"blocks": {
		"body": "Text",
		"button": "Button",
		"greeting": "Greeting",
		"heading": "Heading",
		"link_body": "Text of the link",
		"note": "Closing note",
		"preview": "Inbox preview",
		"subject": "Subject"
	},
	"columns": {
		"email": "Email",
		"en": "English",
		"it": "Italian"
	},
	"content_title": "Email content",
	"default_text": "Default text",
	"emails": {
		"E1": "Student sign-in code",
		"G1": "Back-office account invite",
		"G10": "New residence assigned to a manager"
	},
	"error": "The texts could not be loaded. Reload the page.",
	"history": "Versions",
	"history_default": "Version 1, default text",
	"history_item": "Version {{version}}, {{date}}, {{name}}",
	"issues": {
		"empty": "Write the text of this block.",
		"malformed_variable": "A brace is not part of a variable: write a variable with one brace on each side, like {nome}.",
		"missing_variable": "{{variable}} is missing: put it back in the text.",
		"repeated_variable": "{{variable}} can be used only once in this block.",
		"unknown_block": "This block does not exist in this email.",
		"unknown_variable": "{{variable}} cannot be used here."
	},
	"legal": {
		"description": "The offer (E9) and the PECs (P1-P4) belong to the call rules: they are not edited here and are read in the call notice PDF of each residence.",
		"title": "Texts with legal value"
	},
	"locales": {
		"en": "English",
		"it": "Italian"
	},
	"not_found": "This email has no editable text.",
	"page_title": "Email texts",
	"preview_title": "Preview",
	"required": "Required: {{variables}}.",
	"save": "Save a new version",
	"saved": "New version saved: the next emails will use this text.",
	"subject": "Subject:",
	"variables": "Variables:",
	"variables_global": "You can use {piattaforma} in any text: it is replaced with the name of the platform.",
	"version_on": "Version {{version}} of {{date}}"
}
